import type { CSSProperties } from 'react';
import type { DmNotification } from '../../../services/dmNotifications';
import { formatShortDate } from '../../../utils/dates';
import { NotificationInstruction } from './NotificationInstruction';
import { NotificationLevelPill } from './NotificationLevelPill';
import { instructionTexts, notificationTitle } from './notificationText';

// Level | Date | Notification | Patient instruction | Team instruction, identical on every sub-row so they align.
const SUB_TABLE_GRID = 'grid grid-cols-[84px_88px_minmax(0,1fr)_minmax(0,1.2fr)_minmax(0,1.2fr)]';

interface NotificationLineProps {
    notification: DmNotification;
    // Wider than its cell: the sub-table runs on over the neighbouring cells, which stay empty on sub-rows.
    width: string;
}

export function NotificationLine({ notification, width }: NotificationLineProps) {
    const title = notificationTitle(notification);
    const { patient, team } = instructionTexts(notification);
    const style: CSSProperties = { width };
    return (
        <div className={`${SUB_TABLE_GRID} items-center gap-x-4 pl-9`} style={style}>
            <span>
                <NotificationLevelPill level={notification.level} />
            </span>
            <span className="whitespace-nowrap text-xs leading-5 text-gray-500 tabular-nums">
                {formatShortDate(notification.createdAt)}
            </span>
            <p
                className="line-clamp-2 break-words text-[13px] font-medium leading-5 text-gray-800"
                title={title}
            >
                {title}
            </p>
            {/* Wrapped even when empty, so the grid keeps every column in place. */}
            <div className="min-w-0">
                <NotificationInstruction label="Patient:" text={patient} clamped />
            </div>
            <div className="min-w-0">
                <NotificationInstruction label="Team:" text={team} clamped />
            </div>
        </div>
    );
}
